module.exports = __webpack_public_path__ + "static/media/s_nor_02.dd0eec13.png";